import { accountActionTypes } from '@constants/actionTypes/accountActionTypes';

export const INITIAL_STATE = {
    authFailed: null,
    isAccInactive: null,
    isAccInactiveDormant: null,
    isAccLocked: null,
    status: null
};

export default (state = INITIAL_STATE, action = {}) => {
    switch (action.type) {
        case accountActionTypes.SET_AUTHENTICATION_FAILURE_DATA :
            return action.failureData;
        case accountActionTypes.CLEAR_COMMON_STATE:
            return INITIAL_STATE;
        default:
            return state;
    }

};